module.exports = __webpack_public_path__ + "img/notice.5a4b8bb8.png";